/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navigation_ScimInputs */



/**
* | output |
* | --- |
* | "SCIM Provisioning" |
*
* @param {Navigation_ScimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const navigation_scim = /** @type {((inputs?: Navigation_ScimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navigation_ScimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM-Bereitstellung")
	return /** @type {LocalizedString} */ ("SCIM Provisioning")
});